import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { Field } from '../../models/field.interface';
import { TypeCesEnum } from 'src/app/domain/registration/enums/type-ces.enum';
import { IFieldConfig } from 'src/app/domain/IFieldConfig';

@Component({
  selector: 'form-cancel-save',
  styleUrls: ['form-cancel-save.component.scss'],
  template: `
    <div class="dynamic-field form-button" [formGroup]="group" align="end">
      <button
        type="button"
        mat-raised-button
        ngClass="{{
          typeCes !== typeCesEnum.SHOW ? 'btn-cancel' : 'btn-close'
        }}"
        cdkFocusInitial
        (click)="action.emit()"
      >
        {{ typeCes !== typeCesEnum.SHOW ? config.labelCancel : 'FECHAR' }}
      </button>
      <button
        class="btn-create-edit"
        *ngIf="typeCes !== typeCesEnum.SHOW"
        style="margin-left: 8px;"
        mat-raised-button
        cdkFocusInitial
        [disabled]="config.disabled"
        type="submit"
      >
        {{ typeCes === typeCesEnum.EDIT ? 'EDITAR' : 'CRIAR' }}
      </button>
    </div>
  `,
})
export class FormCancelSaveComponent implements Field {
  action: EventEmitter<any>;
  config: IFieldConfig;
  group: FormGroup;
  typeCes?: TypeCesEnum | undefined;

  get typeCesEnum() {
    return TypeCesEnum;
  }
}
